import { HttpMethod, Command } from "~/extensions/api";
export class UpdateInformationCommand extends Command {
    constructor(model) {
        super(HttpMethod.Post, "information/update");
        this.responseContent = model.firstResponse.responseContent;
        this.responseReason = model.firstResponse.responseReason;
        this.informationNo = model.informationNo;
    }
    responseContent = null;
    responseReason = "";
    informationNo = null;
}
